<div
  class="flex min-h-dvh w-full flex-col bg-gradient-to-t from-white to-brand-primary-lightest"
>
  <header class="flex shrink-0 justify-center px-4 pb-3 pt-8">
    <div class="flex h-7 w-40 items-center justify-center">
      <img
        src="assets/images/my-world-logo.webp"
        alt="Logo Meu Mundo"
        class="select-none object-cover"
      />
    </div>
  </header>

  <!-- Ocupa o espaço entre logo e rodapé e centra o bloco (vertical + horizontal). -->
  <div
    class="flex min-h-0 flex-1 flex-col items-center justify-center px-4 pb-8 pt-4 sm:px-6"
  >
    <div
      class="mx-auto flex w-full max-w-md flex-col items-center gap-8 text-neutral-low-dark"
    >
      <ui-spin-loader
        class="shrink-0"
        variant="primary"
        orientation="vertical"
        [size]="devAuthUi.showDevSplashChrome() ? 'md' : 'lg'"
        [title]="devAuthUi.splashTitle()"
        [message]="devAuthUi.splashMessage()"
      />

      @if (devAuthUi.showDevSplashChrome()) {
        <section
          class="w-full shrink-0 rounded-xl border border-brand-primary-light bg-neutral-hight-pure px-4 py-4 shadow-md/30"
          aria-label="Modo desenvolvimento local"
        >
          <div class="flex gap-4">
            <div
              class="flex size-11 shrink-0 flex-col items-center justify-center rounded-lg bg-brand-primary-lighter text-xs font-bold uppercase leading-none tracking-wide text-brand-primary-dark"
              aria-hidden="true"
            >
              Dev
            </div>
            <div class="min-w-0 flex-1 space-y-3">
              <div>
                <p
                  class="text-xs font-semibold uppercase tracking-wide text-brand-primary-dark"
                >
                  Ambiente local
                </p>
                <p class="mt-1 text-sm leading-snug text-neutral-low-medium">
                  Login interno com credenciais e captcha neste host.
                </p>
              </div>
              <dl
                class="space-y-2 border-t border-neutral-hight-medium pt-3 text-xs"
              >
                <div
                  class="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"
                >
                  <dt class="shrink-0 font-medium text-neutral-low-light">
                    Parâmetro
                  </dt>
                  <dd
                    class="text-right font-mono text-sm text-neutral-low-dark"
                  >
                    ?mode=dev
                  </dd>
                </div>
                <div
                  class="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"
                >
                  <dt class="shrink-0 font-medium text-neutral-low-light">
                    Rota
                  </dt>
                  <dd
                    class="break-all text-right font-mono text-sm text-neutral-low-dark"
                  >
                    /internal-login
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </section>
      }
    </div>
  </div>

  <footer class="flex shrink-0 justify-center px-4 pb-6 pt-2">
    <span class="select-none text-xs text-neutral-low-light">
      © {{ year() }} Meu Mundo. Todos os direitos reservados.
    </span>
  </footer>
</div>
